<
<template>
	<div class="c-popup-folder-options" v-if="target && buttonSelector">
		<Popup
			:buttonSelector="buttonSelector"
			:active="options.active"
			:target="target"
			@onClose="onClose"
			:offset="offset"
		>
			<div class="c-popup-folder-options__inner">
				<a v-if="!folder.default" href="#" @click.prevent="onEditFolder">
					<svg
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M15.0858 2.99997C15.8668 2.21892 17.1332 2.21892 17.9142 2.99997L21 6.08576C21.7811 6.86681 21.781 8.13314 21 8.91418L19.4142 10.5L13.5 4.58576L15.0858 2.99997Z"
							fill="currentColor"
						/>
						<path
							d="M12.0858 5.99997L2.58579 15.5C2.21071 15.875 2 16.3838 2 16.9142V20C2 21.1045 2.89543 22 4 22H7.08579C7.61622 22 8.12493 21.7893 8.5 21.4142L18 11.9142L12.0858 5.99997Z"
							fill="currentColor"
						/>
					</svg>

					<span> Edit Folder </span>
				</a>
				<a href="#" @click.prevent="onAddBoard">
					<svg
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM16 12.9999C16.5523 12.9999 17 12.5522 17 11.9999C17 11.4476 16.5523 10.9999 16 10.9999L13 11V8.00012C13 7.44784 12.5523 7.00012 12 7.00012C11.4477 7.00012 11 7.44784 11 8.00012V11L7.99997 11.0001C7.44769 11.0001 6.99998 11.4479 7 12.0001C7.00002 12.5524 7.44774 13.0001 8.00003 13.0001L11 13V16C11 16.5523 11.4477 17 12 17C12.5523 17 13 16.5523 13 16V13L16 12.9999Z"
							fill="currentColor"
						/>
					</svg>

					<span> Add Board </span>
				</a>
				<a
					v-if="!folder.default"
					href="#"
					class="danger"
					@click.prevent="onDelete"
				>
					<svg
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M2 5C2 3.89543 2.89543 3 4 3H9.46482C10.1335 3 10.758 3.3342 11.1289 3.8906L12.5352 6H20C21.1046 6 22 6.89543 22 8V18C22 19.1046 21.1046 20 20 20H9.82917C10.1839 18.9942 9.98621 17.8371 9.23618 17C10.2916 15.8221 10.2533 14.0106 9.12132 12.8787C7.98937 11.7467 6.17791 11.7084 5 12.7638C4.16288 12.0138 3.00578 11.8161 2 12.1708V5Z"
							fill="currentColor"
						/>
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M7.70711 14.2929C8.09763 14.6834 8.09763 15.3166 7.70711 15.7071L6.41421 17L7.70711 18.2929C8.09763 18.6834 8.09763 19.3166 7.70711 19.7071C7.31658 20.0976 6.68342 20.0976 6.29289 19.7071L5 18.4142L3.70711 19.7071C3.31658 20.0976 2.68342 20.0976 2.29289 19.7071C1.90237 19.3166 1.90237 18.6834 2.29289 18.2929L3.58579 17L2.29289 15.7071C1.90237 15.3166 1.90237 14.6834 2.29289 14.2929C2.68342 13.9024 3.31658 13.9024 3.70711 14.2929L5 15.5858L6.29289 14.2929C6.68342 13.9024 7.31658 13.9024 7.70711 14.2929Z"
							fill="currentColor"
						/>
					</svg>

					<span> Delete Folder </span>
				</a>
			</div>
		</Popup>
	</div>
</template>

<script>
import Popup from './index';

export default {
	components: {
		Popup,
	},

	data: function () {
		return {
			offset: [0, 4],
			options: {
				active: false,
			},
			tags: [
				{
					name: 'All Ads',
					slug: 0,
				},
				{
					name: 'Active',
					slug: 1,
				},
				{
					name: 'Inactive',
					slug: 2,
				},
			],
			selectedActiveAds: 0,
		};
	},

	props: {
		active: {
			type: Boolean,
			default: false,
		},
		target: {},
		folder: {},
		type: {
			type: String,
		},
	},

	watch: {
		active: function () {
			setTimeout(() => {
				if (this.active) {
					this.options.active = true;
				} else {
					this.options.active = false;
				}
			}, 1);
		},
		selectedActiveAds: function () {
			this.$emit('input', this.selectedActiveAds);
		},
	},

	computed: {
		buttonSelector: function () {
			if (!this.target) {
				return;
			}
			let classList = this.target.classList;

			if (classList.length < 2) {
				return;
			}

			let selector = classList[1];

			return selector;
		},
	},

	methods: {
		onEditFolder: function () {
			this.$emit('onClose');
			this.$store.dispatch('folders/setEdit', this.folder.id);
		},

		onAddBoard: function () {
			this.$emit('onClose');
			this.$emit('onAddBoard', this.folder);
		},
		onDelete: function () {
			this.$emit('onClose');
			this.$emit('onDelete', this.folder);
		},
		onClose: function () {
			this.$emit('onClose');
		},
	},

	created: function () {},
};
</script>

<style lang="scss">
.c-popup-folder-options {
	.c-popup {
		width: 160px;

		background-color: hsl(var(--p), 5%, 18%);
		box-shadow: inset 0 -1px 1px #0000001a, inset 0 1px 1px #ffffff08,
			inset 0 5px 20px 1px #ffffff05, 0 2px 5px #3c42570a, 0 1px 1px #0000000f,
			0 0 0 1px #00000013;
		transition: all var(--transition-time) ease-out;

		&__arrow {
			display: none;
		}
	}
	article {
		//padding: var(--margin) var(--margin-lg);
	}

	&__inner {
		border-radius: var(--border-radius-lg);
		overflow: hidden;
		a {
			width: 100%;
			display: flex;
			padding: var(--margin);
			align-items: center;
			color: var(--color-font);
			font-weight: 500;
			font-size: var(--font-size-xs);
			transition: all 120ms ease-out;
			text-decoration: none !important;
			user-select: none;

			&.danger {
				color: var(--color-danger);
			}

			svg {
				width: 20px;
				height: 20px;
				margin-right: var(--margin);
			}

			span {
				line-height: 1;
			}

			&:hover,
			&:active {
				background-color: hsl(var(--p), 5%, 24%);
			}

			&:not(:last-child) {
				border-bottom: hsl(var(--p), 5%, 24%) solid 1px;
			}
		}
	}
}
</style>
